define('boxes/withdraw-result-box',['jquery', 'boxes/box', 'boxes/events/paymentEvent', 'boxes/helpers/payment-helpers', 'payment/paymentOperationMetadata',
    'all/paymentServices-toggles'], function ($, box, paymentEvent, paymentHelpers, paymentOperationMetadata, paymentServicesToggles) {

    'use strict';

    function getPendingWithdrawalsUrl() {
        
        return paymentServicesToggles.useNewPaymentFormDataService() 
            ? '/PaymentFormDataService/getPendingWithdrawals' : '/pp?flow=GetPendingWithdrawals';
    }

    function init(withdrawResult) {
        withdrawResult.model.modeClass = withdrawResult.model.confirmedClass;
        
        withdrawResult.$controller.on(paymentEvent.PENDING, function (event, messageData) {
            withdrawResult.model.modeClass = withdrawResult.model.pendingClass;
            updatePendingMessage(withdrawResult, messageData);
        });

        withdrawResult.$controller.on(paymentEvent.AMOUNT_IN_TRANSACTION, function (event, amount) {
            var $withdrawAmount = withdrawResult.$box.find('.withdraw-amount');
            $withdrawAmount.text(amount);
        });
    }

    function updatePendingMessage(withdrawResult, messageData) {
        var $pendingMessage = withdrawResult.$box.find('.message.pendingMode');
        if (messageData !== undefined) {
            $.each(messageData, function (key, value) {
                if (paymentHelpers.isHTML(value)) {
                    $pendingMessage.find('.' + key).html(value);
                } else {
                    $pendingMessage.find('.' + key).text(value);
                }
            });
        }
    }

    function getSeeProgressButton(withdrawResult) {
        return withdrawResult.$box.find('.see-progress');
    }

    function renderMode(withdrawResult) {
        var $modeDependentElements = withdrawResult.$box.find('.modeDependent');
        $modeDependentElements.hide();

        var $currentModeElements = withdrawResult.$box.find(withdrawResult.model.modeClass);
        $currentModeElements.show();

        var $seeProgressButton = getSeeProgressButton(withdrawResult);
        if (withdrawResult.model.showInProgressButton) {
            $seeProgressButton.show();
        } else {
            $seeProgressButton.hide();
        }
    }

    function firstWithdrawTrackingNameModifier(result, withdrawResult) {
        var trackingWithdraw;
        if (result) {
            trackingWithdraw = 'first ' + withdrawResult.$box.data('trackingName');
        } else {
            trackingWithdraw = withdrawResult.$box.data('trackingName');
            trackingWithdraw = trackingWithdraw.replace('first ', '');
        }
        withdrawResult.$box.data('trackingName', trackingWithdraw);
    }

    var view = {
            render: function (withdrawResult) {
                renderMode(withdrawResult);
                // Reset render mode to next time
                withdrawResult.model.modeClass = withdrawResult.model.confirmedClass;
            }
        },
        model = {
            pendingClass: '.pendingMode',
            confirmedClass: '.confirmedMode',
            modeClass: undefined,
            showInProgressButton: true,

            init: function (withdrawResult) {
                init(withdrawResult);
            },
            beforeRender: function (withdrawResult) {
                var ajaxPromise = box.ajax(withdrawResult, {
                    url: getPendingWithdrawalsUrl(),
                    data: { box: 'withdrawResult' },
                    type: 'GET'
                }, function (data, ajaxPromise) {
                    if (paymentServicesToggles.useNewPaymentFormDataService()) {
                        withdrawResult.model.showInProgressButton = (data.length > 0);
                        ajaxPromise.resolve();
                    } else {
                        withdrawResult.model.showInProgressButton = !((data.RESULT === 'OK' && data.pendingWithdrawals.length < 1) || data.RESULT === 'NOT_OK');
                        ajaxPromise.resolve();
                    }
                });
                $.when(paymentOperationMetadata.checkFirstPaymentOperation()).done(function(result){
                    firstWithdrawTrackingNameModifier(result, withdrawResult);
                });


                return [ajaxPromise.promise()];
            },
            afterRender: function (withdrawResult) {
                var $seeProgressButton = getSeeProgressButton(withdrawResult);
                $seeProgressButton.off('click').on('click', function (event) {
                    event.preventDefault();
                    $(this).off('click');
                    withdrawResult.$controller.nextBox();
                });
            }
        };


    return {
        create: function ($box, $controller) {
            return box.create($box, $controller, view, model);
        }
    };
});

